import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreEffects } from './state/core.effects';
import { NgModule, APP_INITIALIZER, LOCALE_ID  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppInitService } from './app-init.service';
// Modules imports
import { StoreModule } from '@ngrx/store';
import { LobbyModule } from './lobby/lobby.module';
import { AppointmentModule } from './appointment/appointment.module';
import { ReportModule } from './report/report.module';
import { FormsModule } from '@angular/forms';
import { AuthenticationModule } from './authentication/authentication.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';

// Components imports
import { SignoutModalComponent } from './shared/layout/app-layout/app-header/signout/signout-modal/signout-modal.component';
import { AppComponent } from './app.component';


// Store Reducers imports
import { messageHubReducer } from './state/app.reducer';

// Global services imports
import { OAuthModule, OAuthStorage, ValidationHandler } from 'angular-oauth2-oidc';
import { EnvServiceProvider } from './core/services/env.service.provider';

import { Globals } from './core/services/globals';
import { ModalpopupComponent } from './shared/modalpopup/modalpopup.component';
import { UnSavedChangesRouteGuard } from './shared/routeguards/unsavedChangesRouteGuard';
import { ModalPopupImplComponent } from './shared/modalpopup/modal-popup-impl/modal-popup-impl.component';
import { AdminModule } from './admin/admin.module';
import { EffectsModule } from '@ngrx/effects';
import { coreReducer } from './state/core.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { ChartsModule } from '@progress/kendo-angular-charts';

import 'hammerjs';
import { NotificationGroupPopupComponent } from './shared/modalpopup/notification-Group/notification-group-popup/notification-group-popup.component';

import { DatePipe } from '@angular/common'
import { RedirectGuard } from './shared/routeguards/redirect.guard';
import { TranslationLoaderFacade } from './admin/localization/translation-loader.facade';
import { TranslationInitializerService } from './admin/localization/translation-initializer.service';
import { CustomCompiler } from './admin/localization/CustomCompiler';
import { KendoCultureService } from './shared/services/kendo-culture.service';
import { IntlService } from '@progress/kendo-angular-intl';


export declare const window: any;
@NgModule({
  declarations: [
    AppComponent,
  ],

  imports: [
    StoreModule.forRoot({ messageHub: messageHubReducer, CoreState: coreReducer }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: false

    }),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [],
        sendAccessToken: true
      }
    }),
    TooltipModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    CoreModule,
    DialogsModule,
    AppointmentModule,
    LobbyModule,
    AuthenticationModule,
    SharedModule,
    NgbModule,
    DialogModule,
    AdminModule,
    EffectsModule.forRoot([CoreEffects]),
    ChartsModule,
    ReportModule,
    TranslateModule.forRoot({
      compiler: {provide: TranslateCompiler, useClass: CustomCompiler}
    })
  ],

  providers: [EnvServiceProvider, Globals, NgbActiveModal, UnSavedChangesRouteGuard, RedirectGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () => appInitService.loadConfigurations$(),
      deps: [AppInitService], multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (translationInitializer: TranslationInitializerService) => () => translationInitializer.init(),
      deps: [TranslationInitializerService],
      multi: true
    },
    { provide: OAuthStorage, useValue: localStorage },
    { provide: IntlService, useClass: KendoCultureService }, 
    { provide: LOCALE_ID, useValue: 'en' },
    DatePipe, TranslationLoaderFacade],
  bootstrap: [AppComponent],
})
export class AppModule { }
